<template>
  <Layout>
    <PageHeader :title="title" :items="items"/>
    <Aguarde :show="httpSend"></Aguarde>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row border-bottom mb-3">
              <div class="col-md-12">
                <b-form @submit.prevent="listPedidos">
                  <div class="row">
                    <div class="col-md-4">
                      <b-form-group label="Status" label-for="filtros-status">
                        <select id="filtros-status"
                                v-model="filtros.status"
                                class="custom-select" type="text">
                          <option value="">Todos</option>
                          <option value="1">Pendente</option>
                          <option value="2">Rejeitado</option>
                          <option value="3">Aprovado</option>
                        </select>
                      </b-form-group>
                    </div>
                    <div class="col-md-4">
                      <b-form-group
                          label="Número"
                          label-for="codigo">
                        <input
                            id="codigo"
                            v-model="filtros.numero"
                            type="text"
                            maxlength="10"
                            class="form-control"
                            placeholder="Número final">
                      </b-form-group>
                    </div>
                    <div class="col-md-4">
                      <b-form-group
                          label="´"
                          class="text-white">
                        <button type="button" @click="listPedidos()" class="btn btn-label btn-primary"><i
                            class="bx bx-search label-icon"></i>
                          Pesquisar
                        </button>
                      </b-form-group>
                    </div>
                  </div>
                </b-form>
              </div>
            </div>
            <div v-if="pedidos && pedidos.length > 0" class="row">
              <div class="col-md-12">
                <tabela-cancelamento :pedidos="pedidos"></tabela-cancelamento>
              </div>
              <div class="col-lg-12">
                <paginate
                    :page-count="total_paginas"
                    :page-range="3"
                    :margin-pages="3"
                    :click-handler="proximaPagina"
                    :prev-text="'Página anterior'"
                    :next-text="'Próxima página'"
                    :prev-link-class="'page-link'"
                    :next-link-class="'page-link'"
                    :page-link-class="'page-link'"
                    :container-class="'pagination pagination-rounded justify-content-center mt-4'"
                    :page-class="'page-item'">
                </paginate>
              </div>
            </div>
            <div v-else class="row">
              <div class="col-sm-12">
                <div role="alert" aria-live="polite" aria-atomic="true" class="alert alert-primary">
                  <i class="mdi mdi-alert-outline mr-2"></i> Não foi localizada nenhum pedido de cancelamento
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
<script>
import Paginate from 'vuejs-paginate'
import Layout from "@/router/layouts/main";
import Aguarde from "@/components/widgets/aguarde";
import appConfig from "@/dados/app.config.json";
import PageHeader from "@/components/page-header";
import TabelaCancelamento from "../../../components/geral/tabela-cancelamento"

const {listNotasPedidosCancelamento} = require("../../../api/nfse/nota");

export default {
  page: {
    title: "Pedidos de Cancelamento de NFS-e",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Aguarde,
    Paginate,
    TabelaCancelamento
  },
  data() {
    return {
      title: "Pedidos de Cancelamento de NFS-e",
      items: [
        {
          text: 'Painel',
          href: '/painel',
        },
        {
          text: 'Lista de Notas',
          href: '/contribuinte/nota-fiscal/lista',
        },
        {
          text: 'Pedidos de Cancelamento',
          active: true,
        },
      ],
      httpSend: false,
      filtros: {
        pagina: 1,
        status: '',
        numero: "",
        nome: ""
      },
      total_paginas: 0,
      pedidos: []
    };
  },
  created() {
    if (this.empresa) {
      this.listPedidos();
    }
  },
  computed: {
    empresa: {
      get: function () {
        return this.$store.state.auth.currenEmpresa;
      },
    },
  },
  methods: {
    proximaPagina(pageNum) {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
      this.filtros.pagina = pageNum;
      this.listPedidos()
    },
    listPedidos() {
      this.httpSend = true;
      listNotasPedidosCancelamento(this.empresa.eco_codigo, this.filtros).then(result => {
        if (result.status) {
          this.total_paginas = result.dados.paginas;
          this.pedidos = result.dados.pedidos;
        }
      }).catch(error => {
        console.log(error)
      }).finally(() => {
        this.httpSend = false;
      })
    },
  }
};
</script>


